import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FinanceiroComponent } from './financeiro.component';
import { GestaoFinanceiraComponent } from './gestao-financeira/gestao-financeira.component';
import { AuthGuardService } from '../../shared/filters/auth-guard.service';

const routes: Routes = [{
  path: '',
  component: FinanceiroComponent,
  children: [
    {
      path: 'gestao-financeira',
      component: GestaoFinanceiraComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['GESTAO_FINANCEIRA'] }
    },

  ],

}];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
})
export class FinanceiroRoutingModule { }

export const routedComponents = [
  FinanceiroComponent,
  GestaoFinanceiraComponent,

];


